import { render, staticRenderFns } from "./users.vue?vue&type=template&id=9972aaf6&scoped=true"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=9972aaf6&prod&scoped=true&lang=css&external"
import style1 from "./users.vue?vue&type=style&index=1&id=9972aaf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9972aaf6",
  null
  
)

export default component.exports